/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { Injectable } from '@angular/core';
import { EntitiesModel, PaginationModel } from '@lm-nx-frontend/lm-inf-core';

import { TableService } from '@lm-nx-frontend/lm-inf-ui';
import { Observable } from 'rxjs';
import { OrganizationTableType } from '../../shared/organization.model';
import { SubListService } from '../../shared/sub-list/sub-list.service';
import {PermissionService, UserGroupService} from "../../../core/services";
import {OrganizationItemStatus, Permission, UserGroup} from "../../../core/model";

@Injectable({
  providedIn: 'root',
})
export class UserGroupPermissionListService extends SubListService<Permission> {
  protected tableType = OrganizationTableType.USER_GROUP_PERMISSIONS;
  protected _domainType = OrganizationTableType.PERMISSION;

  constructor(
    protected tableService: TableService,
    protected userGroupService: UserGroupService,
    protected permissionService: PermissionService
  ) {
    super(tableService);
  }

  /**
   *
   * @override
   * Loads all b2b users.
   *
   * @param code The user group code.
   */
  protected load(
    pagination: PaginationModel,
    code: string
  ): Observable<EntitiesModel<Permission> | undefined> {
    return this.userGroupService.getAvailableOrderApprovalPermissions(
      code,
      pagination
    );
  }

  /**
   * @override
   * Assign user to the user group.
   */
  assign(
    userGroupCode: string,
    permissionCode: string
  ): Observable<OrganizationItemStatus<UserGroup>> {
    this.userGroupService.assignPermission(userGroupCode, permissionCode);
    return this.permissionService.getLoadingStatus(permissionCode);
  }

  /**
   * @override
   * Unassigns the user from the user group.
   */
  unassign(
    userGroupCode: string,
    permissionCode: string
  ): Observable<OrganizationItemStatus<UserGroup>> {
    this.userGroupService.unassignPermission(userGroupCode, permissionCode);
    return this.permissionService.getLoadingStatus(permissionCode);
  }
}
